import request from '@/axios';

// 获取导航列表
export const getLogList = (params) => {
    return request({
        url: `/lebo-desk/common/operation-log/page`,
        method: 'get',
        params
    })
}